<template>
  <!-- Call / Chat / SMS shown on the page (same pill style; hover fills the pill, the icon circle turns white) -->
  <div class="inline-flex flex-wrap items-center gap-[8px]">
    <a v-if="phone" :href="'tel:' + phone" aria-label="Call consumer"
      class="group pl-[4px] pr-[12px] rounded-full flex items-center gap-[6px] border-1 bg-[#fff] text-[13px] font-roboto no-underline transition border-[#F67280] text-[#F67280] hover:!bg-[#F67280] hover:!text-white [@media(max-width:1023px)]:!bg-[#F67280] [@media(max-width:1023px)]:!text-white"
      :style="{ height: size + 'px' }">
      <span
        class="w-[24px] h-[24px] rounded-full flex items-center justify-center bg-[#F67280] transition group-hover:!bg-white [@media(max-width:1023px)]:!bg-white">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 32 32">
          <path d="M0 0h32v32H0z" fill="none" />
          <path class="fill-white group-hover:fill-[#F67280] [@media(max-width:1023px)]:!fill-[#F67280] transition"
            d="M24 13h-2a3.003 3.003 0 0 0-3-3V8a5.006 5.006 0 0 1 5 5" />
          <path class="fill-white group-hover:fill-[#F67280] [@media(max-width:1023px)]:!fill-[#F67280] transition"
            d="M28 13h-2a7.01 7.01 0 0 0-7-7V4a9.01 9.01 0 0 1 9 9m-7.667 8.482l2.24-2.24a2.17 2.17 0 0 1 2.337-.48l2.728 1.092A2.17 2.17 0 0 1 29 21.866v4.961a2.167 2.167 0 0 1-2.284 2.169C7.594 27.806 3.732 11.61 3.015 5.408A2.162 2.162 0 0 1 5.169 3h4.873a2.17 2.17 0 0 1 2.012 1.362l1.091 2.728a2.17 2.17 0 0 1-.48 2.337l-2.24 2.24s1.242 8.732 9.908 9.815" />
        </svg>

      </span>
      Call
    </a>
    <button v-if="showChat" type="button" aria-label="Chat with consumer"
      class="group pl-[4px] pr-[12px] rounded-full flex items-center gap-[6px] border-1 bg-[#fff] text-[13px] font-roboto no-underline transition border-[#168EFF] text-[#168EFF] hover:!bg-[#168EFF] hover:!text-white [@media(max-width:1023px)]:!bg-[#168EFF] [@media(max-width:1023px)]:!text-white"
      :style="{ height: size + 'px' }" @click="chooseChat">
      <span
        class="w-[24px] h-[24px] rounded-full flex items-center justify-center bg-[#168EFF] transition group-hover:!bg-white [@media(max-width:1023px)]:!bg-white">

        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16">
          <path d="M0 0h16v16H0z" fill="none" />
          <path class="fill-white group-hover:fill-[#168EFF] [@media(max-width:1023px)]:!fill-[#168EFF] transition"
            d="M11.5 7a4.5 4.5 0 1 1-2.182 8.437l-1.789.544a.41.41 0 0 1-.51-.51l.544-1.79A4.5 4.5 0 0 1 11.5 7M7.259 8a5.5 5.5 0 0 0-.656 1H2.5a1 1 0 0 0-1 1c0 .508.304.992.932 1.375S3.966 12 5 12c.357 0 .698-.031 1.018-.085q.038.508.164.986C5.802 12.964 5.406 13 5 13c-1.175 0-2.27-.272-3.089-.77C1.091 11.73.5 10.965.5 10a2 2 0 0 1 2-2zM9.5 12a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0-2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM5 1.5A2.75 2.75 0 1 1 5 7a2.75 2.75 0 0 1 0-5.5m6.731 1.009a2.253 2.253 0 0 1 2.023 2.24l-.012.23c-.05.49-.259.933-.572 1.279A5.5 5.5 0 0 0 11.514 6a1.252 1.252 0 1 0-.026 0a5.5 5.5 0 0 0-1.656.258a2.24 2.24 0 0 1-.57-1.28L9.25 4.75a2.25 2.25 0 0 1 2.252-2.252zM5 2.5A1.75 1.75 0 1 0 5 6a1.75 1.75 0 0 0 0-3.5" />
        </svg>

      </span>
      Chat
    </button>
    <button v-if="showChat" type="button" aria-label="Send SMS to consumer"
      class="group pl-[4px] pr-[12px] rounded-full flex items-center gap-[6px] border-1 bg-[#fff] text-[13px] font-roboto no-underline transition border-[#A084E8] text-[#A084E8] hover:!bg-[#A084E8] hover:!text-white [@media(max-width:1023px)]:!bg-[#A084E8] [@media(max-width:1023px)]:!text-white"
      :style="{ height: size + 'px' }" @click="chooseSms">
      <span
        class="w-[24px] h-[24px] rounded-full flex items-center justify-center bg-[#A084E8] transition group-hover:!bg-white [@media(max-width:1023px)]:!bg-white">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
	<path d="M0 0h24v24H0z" fill="none" />
	<path class="fill-white group-hover:fill-[#A084E8] [@media(max-width:1023px)]:!fill-[#A084E8] transition" d="M12 1.333C6.119 1.333 1.333 6.12 1.333 12c0 1.861.495 3.701 1.416 5.295c.318.594-.126 2.669-1.122 3.665a1 1 0 0 0 .653 1.705q.158.008.321.008c1.527 0 3.38-.542 4.587-1.161A10.6 10.6 0 0 0 12 22.667c5.881 0 10.667-4.786 10.667-10.667S17.88 1.333 12 1.333m-4.667 12A1.334 1.334 0 0 1 6 12a1.334 1.334 0 0 1 2.667 0c0 .735-.598 1.333-1.334 1.333m4.667 0A1.334 1.334 0 0 1 10.667 12a1.334 1.334 0 0 1 2.666 0c0 .735-.597 1.333-1.333 1.333m4.667 0A1.335 1.335 0 0 1 15.333 12A1.334 1.334 0 0 1 18 12c0 .735-.597 1.333-1.333 1.333" />
</svg>
      </span>
      SMS
    </button>
  </div>

  <Teleport to="body">
    <!-- customer SMS conversation — same window as the chat (size, header, pinned composer) -->
    <div ref="sms" class="modal fade fxModal chatWindow" tabindex="-1" aria-hidden="true" data-bs-backdrop="static"
      data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-centered" style="max-width: 560px">
        <div class="modal-content">
          <div class="modal-body p-[20px] font-roboto flex flex-col !overflow-hidden">
            <FxModalHeader :title="consumerName || 'SMS'" subtitle="SMS" :dismiss="false" @close="hide('sms')">
              <button type="button" title="Refresh" aria-label="Refresh"
                class="ml-[10px] w-[26px] h-[26px] inline-flex items-center justify-center rounded-full border-0 bg-[#EE5851] hover:bg-[#D9443D] align-middle text-[#fff] text-[13px]"
                @click="$refs.smsConv && $refs.smsConv.refresh()">
                <i class="fa fa-refresh" aria-hidden="true" />
              </button>
            </FxModalHeader>
            <SmsConversation v-if="smsOpen" ref="smsConv" class="flex-1 min-h-0" :show-header="false"
              :company-consumer-id="companyConsumerId" :consumer-name="consumerName" />
          </div>
        </div>
      </div>
    </div>
  </Teleport>

  <ChatWindow ref="chat" @closed="$emit('closed', $event)" />
</template>

<script>
import { Modal } from "bootstrap";
import { useToast } from "vue-toastification";
import FxModalHeader from "../nest_components/FxModalHeader.vue";
import ChatWindow from "./ChatWindow.vue";
import SmsConversation from "./SmsConversation.vue";

const toast = useToast();

export default {
  components: { FxModalHeader, ChatWindow, SmsConversation },
  props: {
    bookingId: { type: [Number, String], default: null },
    orderId: { type: [Number, String], default: null },
    companyConsumerId: { type: [Number, String], default: 0 },
    consumerName: { type: String, default: "" },
    // consumer phone for the Call pill (hidden when empty)
    phone: { type: String, default: "" },
    // Chat / SMS follow the page's rules (e.g. hidden for completed jobs); Call always shows when there is a phone
    showChat: { type: Boolean, default: true },
    // button height in px (S&R consumer card uses 36, RQ detail 30)
    size: { type: [Number, String], default: 30 },
  },
  emits: ["closed"],
  data() {
    return { smsOpen: false };
  },
  mounted() {
    this.$refs.sms.addEventListener("hidden.bs.modal", this.onSmsHidden);
  },
  beforeUnmount() {
    this.$refs.sms?.removeEventListener("hidden.bs.modal", this.onSmsHidden);
    this.modals?.sms?.dispose();
  },
  methods: {
    modal(name) {
      this.modals = this.modals || {};
      this.modals[name] = this.modals[name] || new Modal(this.$refs[name]);
      return this.modals[name];
    },
    hide(name) {
      this.modals?.[name]?.hide();
    },
    chooseChat() {
      this.$refs.chat.open(this.bookingId ? { bookingId: this.bookingId } : { orderId: this.orderId });
    },
    chooseSms() {
      if (!(Number(this.companyConsumerId) > 0)) {
        toast.error(`Customer SMS is not available for this ${this.bookingId ? "job" : "order"}`);
        return;
      }
      this.smsOpen = true;
      this.modal("sms").show();
    },
    onSmsHidden() {
      this.smsOpen = false;
    },
  },
};
</script>
